// Libraries
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HolidayService } from "../../holiday/services/HolidayService";
import { User } from "../../common/modules/user/models/User";
import { SessionStorageService } from "../../common/modules/core/services";
import { SessionService } from "../../common/modules/user/services/SessionService";
import { UserService } from "../../common/modules/user/services/UserService";
import { VivaService } from "../services/VivaService";
import { EmailService } from "../../asa/services/EmailService";
import { Email } from "../../asa/models";
import * as _ from "lodash";
import { Observable } from "rxjs";

@Component({
  selector: "parent-navigate",
  template: require("./ParentNavigateComponent.html"),
  styles: [require("./ParentNavigateComponent.sass")],
})
export class ParentNavigateComponent implements OnInit {
  private services: any = [];
  private hostName: string;
  userData: any;
  message: string;
  messageType: string;
  vivaObject: any;
  private myaisToken: string;
  private emailList: Email[];
  private parent: any;
  private token: any;
  private showHandBook: boolean = false;
  private showHolModel: boolean = false;
  private showStudentAccident: boolean = false;
  private isOnlyEIS: boolean = false;
  protected devEnv: any = [
    "services.eca.dev.nascorp.vn",
    "myais.eca.dev.nascorp.vn",
    "camp.eca.dev.nascorp.vn",
    "asa.eca.dev.nascorp.vn",
    "holiday.eca.dev.nascorp.vn",
    "bus.eca.dev.nascorp.vn",
    "conference.eca.dev.nascorp.vn",
  ];
  protected localEnv: any = ["services.local.eca.dev.nascorp.vn"];
  protected testEnv: any = [
    "services.eca.test.nascorp.vn",
    "myais.eca.test.nascorp.vn",
    "camp.eca.test.nascorp.vn",
    "asa.eca.test.nascorp.vn",
    "holiday.eca.test.nascorp.vn",
    "bus.eca.test.nascorp.vn",
    "conference.eca.test.nascorp.vn",
  ];
  protected stagingEnv: any = [
    "auth.eca.uat.nascorp.vn",
    "services.eca.uat.nascorp.vn",
    "asa.eca.uat.nascorp.vn",
    "holidayschool.eca.uat.nascorp.vn",
    "bus.eca.uat.nascorp.vn",
    "outdooreducation.eca.uat.nascorp.vn",
    "reen.eca.uat.nascorp.vn",
    "acs.eca.uat.nascorp.vn",
    "pcbs.eca.uat.nascorp.vn",
  ];
  protected procEnv: any = [
    "services.aisvietnam.com",
    "myais.vn",
    "outdooreducation.aisvietnam.com",
    "asa.aisvietnam.com",
    "holidayschool.aisvietnam.com",
    "bus.aisvietnam.com",
    "pcbs.aisvietnam.com",
  ];
  constructor(
    private router: Router,
    private userService: UserService,
    private sessionService: SessionService,
    private vivaService: VivaService,
    private holidayService: HolidayService,
    private emailService: EmailService,
  ) {}
  ngOnInit() {
    this.getSession();
    this.hostName = window.location.hostname;
    this.userData = this.userService.getUserSessionData();
    this.isOnlyEIS = this.userData.isOnlyEIS;
    if (!this.userData) {
      this.router.navigate(["/"]);
    }
    this.encodeBase64();
    this.getEmailList();
  }

  toManageBac() {
    window.open("http://aisvn.managebac.com/", "_blank");
  }

  toggleParentHandbook() {
    this.showHandBook = !this.showHandBook;
  }

  toggleHolModal() {
    this.showHolModel = !this.showHolModel;
  }

  toggleStudentAccident() {
    this.showStudentAccident = !this.showStudentAccident;
  }

  toEnglishKinAndPri() {
    window.open(
      "https://services.aisvietnam.com/upload/Kindergarten%20and%20Primary%20Parent%20Handbook.pdf",
      "_blank",
    );
  }

  toSecondary() {
    window.open(
      "https://services.aisvietnam.com/upload/Secondary%20Parent%20Handbook.pdf",
      "_blank",
    );
  }

  toSummerPage() {
    window.open(
      "https://services.aisvietnam.com/upload/Summer%20School%20Parent%20Guideline.pdf",
      "_blank",
    );
  }

  // toWinterPage(){
  //     window.open('', "_blank")
  // }

  // toKoreanPage(){
  //     window.open('', "_blank")
  // }

  // toVietnamesePage(){
  //     window.open('', "_blank")
  // }

  toPersonalAccidentInsurancePage() {
    window.open(
      "https://services.aisvietnam.com/upload/AIS_Leaflet_Personal%20Accident.pdf",
      "_blank",
    );
  }

  toClaimFormPage() {
    window.open(
      "https://services.aisvietnam.com/upload/Claim%20Form_PG.pdf",
      "_blank",
    );
  }

  toConferenceBooking() {
    switch (this.hostName) {
      case "services.aisvietnam.com":
        window.location.href = "https://pcbs.aisvietnam.com";
        break;
      case "services.eca.dev.nascorp.vn":
        window.location.href = "http://conference.eca.dev.nascorp.vn/";
        break;
      case "services.eca.test.nascorp.vn":
        window.location.href = "http://conference.eca.test.nascorp.vn/";
        break;
      case "services.eca.uat.nascorp.vn":
        window.location.href = "http://pcbs.eca.uat.nascorp.vn";
        break;
      default:
        window.location.href = "http://conference.local.eca.dev.nascorp.vn";
        break;
    }
  }

  toAsa() {
    switch (this.hostName) {
      case "services.aisvietnam.com":
        window.location.href = "https://asa.aisvietnam.com";
        break;
      case "services.eca.dev.nascorp.vn":
        window.location.href = "http://asa.eca.dev.nascorp.vn/";
        break;
      case "services.eca.test.nascorp.vn":
        window.location.href = "http://asa.eca.test.nascorp.vn/";
        break;
      case "services.eca.uat.nascorp.vn":
        window.location.href = "http://asa.eca.uat.nascorp.vn";
        break;
      default:
        window.location.href = "http://asa.local.eca.dev.nascorp.vn";
        break;
    }
  }

  toSchoolFees() {
    window.location.href = "/api/sso/edpay/token";
  }

  getEmailList() {
    this.emailService.getEmailList().subscribe(
      (emailList) => {
        this.emailList = emailList;
        this.vivaObject = _.find(emailList, { id: "3" });
      },
      (error) => {},
    );
  }

  //Pop up modal add class
  private AddModal(modalType: string) {
    document.getElementById(modalType).style.display = "block";
    console.log(modalType);
  }

  protected closeModal(modalName: string) {
    document.getElementById(modalName).style.display = "none";
  }
  toReenrollemnt() {
    switch (this.hostName) {
      case "services.aisvietnam.com":
        window.location.href = "https://reen.aisvietnam.com";
        break;
      case "services.eca.dev.nascorp.vn":
        window.location.href = "http://reen.eca.dev.nascorp.vn";
        break;
      case "services.eca.test.nascorp.vn":
        window.location.href = "http://reen.eca.test.nascorp.vn";
        break;
      case "services.eca.uat.nascorp.vn":
        window.location.href = "http://reen.eca.uat.nascorp.vn";
        break;
      default:
        window.location.href = "http://reen.local.eca.dev.nascorp.vn";
        break;
    }
  }
  toBus() {
    const params = new URLSearchParams({ email: this.userData.email } as any);
    fetch(
      `${window.location.origin}/api/get-redirect-bus-link?${params.toString()}`,
      {
        method: "GET",
      },
    )
      .then((res) => res.json())
      .then((data: any) => {
        const { redirect_url } = data;
        if (redirect_url) {
          window.location.href = redirect_url;
        }
      });

    // switch(this.hostName){
    //     case "services.aisvietnam.com":
    //         window.location.href = 'https://bus.aisvietnam.com';
    //         break;
    //     case "services.eca.dev.nascorp.vn":
    //         window.location.href = 'http://bus.eca.dev.nascorp.vn';
    //         break;
    //     case "services.eca.test.nascorp.vn":
    //         window.location.href = 'http://bus.eca.test.nascorp.vn';
    //         break;
    //     case "services.eca.uat.nascorp.vn":
    //         window.location.href = 'http://bus.eca.uat.nascorp.vn';
    //         break;
    //     default:
    //         window.location.href = 'http://bus.local.eca.dev.nascorp.vn';
    //         break;
    // };
  }

  toHoliday() {
    this.convertParent();
  }

  toViva() {
    this.getVivaToken();
  }

  toMyAis() {
    switch (this.hostName) {
      case "services.aisvietnam.com":
        window.location.href = "https://services.aisvietnam.com/calendars";
        break;
      case "services.eca.dev.nascorp.vn":
        window.location.href = "http://services.eca.dev.nascorp.vn/calendars";
        break;
      case "services.eca.test.nascorp.vn":
        window.location.href = "http://services.eca.test.nascorp.vn/calendars";
        break;
      case "services.eca.uat.nascorp.vn":
        window.location.href = "http://services.eca.uat.nascorp.vn/calendars";
        break;
      default:
        window.location.href =
          "http://services.local.eca.dev.nascorp.vn/calendars";
        break;
    }
  }

  toOutDoor() {
    switch (this.hostName) {
      case "services.aisvietnam.com":
        window.location.href = "https://outdooreducation.aisvietnam.com";
        break;
      case "services.eca.dev.nascorp.vn":
        window.location.href = "http://camp.eca.dev.nascorp.vn/";
        break;
      case "services.eca.test.nascorp.vn":
        window.location.href = "http://camp.eca.test.nascorp.vn/";
        break;
      case "services.eca.uat.nascorp.vn":
        window.location.href = "http://outdooreducation.eca.uat.nascorp.vn";
        break;
      default:
        window.location.href = "http://camp.local.eca.dev.nascorp.vn";
        break;
    }
  }

  private convertParent() {
    this.holidayService.convertParent().subscribe(
      (complete) => {
        this.getSession();
        switch (this.hostName) {
          case "services.aisvietnam.com":
            setTimeout(function () {
              window.location.href = "https://holidayschool.aisvietnam.com";
            }, 0);
            break;
          case "services.eca.dev.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.eca.dev.nascorp.vn/";
            }, 0);
            break;
          case "services.eca.test.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.eca.test.nascorp.vn/";
            }, 0);
            break;
          case "services.eca.uat.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holidayschool.eca.uat.nascorp.vn";
            }, 0);
            break;
          case "services.local.eca.dev.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.local.eca.dev.nascorp.vn";
            }, 0);
            break;
        }
      },
      (error) => {
        switch (this.hostName) {
          case "services.aisvietnam.com":
            setTimeout(function () {
              window.location.href = "https://holidayschool.aisvietnam.com";
            }, 0);
            break;
          case "services.eca.dev.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.eca.dev.nascorp.vn/";
            }, 0);
            break;
          case "services.eca.test.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.eca.test.nascorp.vn/";
            }, 0);
            break;
          case "services.eca.uat.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holidayschool.eca.uat.nascorp.vn";
            }, 0);
            break;
          case "services.local.eca.dev.nascorp.vn":
            setTimeout(function () {
              window.location.href = "http://holiday.local.eca.dev.nascorp.vn";
            }, 0);
            break;
        }
      },
    );
  }

  private getSession() {
    this.sessionService.getSession().subscribe(
      (user) => {
        this.userService.setUserSessionData(user);
        this.userService.userDataChanged(user);
        this.userData = this.userService.getUserSessionData();
      },
      (error) => {
        //TO DO: Handle any error if needed in the furture
        this.message = "";
        this.messageType = "alert";
        this.router.navigate(["/hol-login"]);
      },
    );
  }

  private getVivaToken() {
    Observable.forkJoin([
      this.sessionService.getCafeteriaUrl(),
      this.sessionService.getSessionDaisy(),
    ]).subscribe(
      (item) => {
        const linkDaisy = item[0];
        const token = item[1];
        const from = `<form id="daisy_from_inner" name="daisy_from_inner" method="POST" action="${linkDaisy.login}" style="display: none">
                                <input type="text" value="${token.accessToken}" name="accessToken" /> 
                                <input type="text" value="${token.parentID}" name="parentID" /> 
                                <input type="text" value="${token.refreshToken}" name="refreshToken" /> 
                                <input type="submit" name="submit_form" value="Submit form" /> 
                            </form>`;
        document.getElementById("daisy_from").innerHTML = from;
        document.forms["daisy_from_inner"].submit();
        document.getElementById("daisy_from").innerHTML = "";
      },
      (error) => {
        this.message = "";
        this.messageType = "alert";
      },
    );
  }

  private getParent() {
    this.holidayService.getParent().subscribe(
      (parent) => {
        this.parent = parent;

        if (this.parent.status === "fill-info") {
          this.router.navigate(["/profile/add-parent"]);
        } else if (this.parent.status == "full") {
          this.router.navigate(["/booking/students"]);
        } else {
          this.router.navigate(["/add-student"]);
        }
      },
      (error) => {
        //TO DO: Handle any error if needed in the furture
        this.message = "";
        this.messageType = "alert";
      },
    );
  }

  encodeBase64() {
    let email = this.userData.email;
    // Encode the String
    let encodedEmail = btoa(email);
    // Encode second time
    let encodedEmail2nd = btoa(encodedEmail);
    return encodedEmail2nd;
  }

  // Convert string SHA1
  SHA1(msg: any) {
    function rotate_left(n: any, s: any) {
      var t4 = (n << s) | (n >>> (32 - s));
      return t4;
    }
    function lsb_hex(val: any) {
      var str = "";
      var i;
      var vh;
      var vl;
      for (i = 0; i <= 6; i += 2) {
        vh = (val >>> (i * 4 + 4)) & 0x0f;
        vl = (val >>> (i * 4)) & 0x0f;
        str += vh.toString(16) + vl.toString(16);
      }
      return str;
    }
    function cvt_hex(val: any) {
      var str = "";
      var i;
      var v;
      for (i = 7; i >= 0; i--) {
        v = (val >>> (i * 4)) & 0x0f;
        str += v.toString(16);
      }
      return str;
    }
    function Utf8Encode(string: any) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n);
        if (c < 128) {
          utftext += String.fromCharCode(c);
        } else if (c > 127 && c < 2048) {
          utftext += String.fromCharCode((c >> 6) | 192);
          utftext += String.fromCharCode((c & 63) | 128);
        } else {
          utftext += String.fromCharCode((c >> 12) | 224);
          utftext += String.fromCharCode(((c >> 6) & 63) | 128);
          utftext += String.fromCharCode((c & 63) | 128);
        }
      }
      return utftext;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xefcdab89;
    var H2 = 0x98badcfe;
    var H3 = 0x10325476;
    var H4 = 0xc3d2e1f0;
    var A, B, C, D, E;
    var temp;
    msg = Utf8Encode(msg);
    var msg_len = msg.length;
    var word_array = new Array();
    for (i = 0; i < msg_len - 3; i += 4) {
      j =
        (msg.charCodeAt(i) << 24) |
        (msg.charCodeAt(i + 1) << 16) |
        (msg.charCodeAt(i + 2) << 8) |
        msg.charCodeAt(i + 3);
      word_array.push(j);
    }
    switch (msg_len % 4) {
      case 0:
        i = 0x080000000;
        break;
      case 1:
        i = (msg.charCodeAt(msg_len - 1) << 24) | 0x0800000;
        break;
      case 2:
        i =
          (msg.charCodeAt(msg_len - 2) << 24) |
          (msg.charCodeAt(msg_len - 1) << 16) |
          0x08000;
        break;
      case 3:
        i =
          (msg.charCodeAt(msg_len - 3) << 24) |
          (msg.charCodeAt(msg_len - 2) << 16) |
          (msg.charCodeAt(msg_len - 1) << 8) |
          0x80;
        break;
    }
    word_array.push(i);
    while (word_array.length % 16 != 14) word_array.push(0);
    word_array.push(msg_len >>> 29);
    word_array.push((msg_len << 3) & 0x0ffffffff);
    for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
      for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
      for (i = 16; i <= 79; i++)
        W[i] = rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
      A = H0;
      B = H1;
      C = H2;
      D = H3;
      E = H4;
      for (i = 0; i <= 19; i++) {
        temp =
          (rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 20; i <= 39; i++) {
        temp =
          (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 40; i <= 59; i++) {
        temp =
          (rotate_left(A, 5) +
            ((B & C) | (B & D) | (C & D)) +
            E +
            W[i] +
            0x8f1bbcdc) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      for (i = 60; i <= 79; i++) {
        temp =
          (rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
          0x0ffffffff;
        E = D;
        D = C;
        C = rotate_left(B, 30);
        B = A;
        A = temp;
      }
      H0 = (H0 + A) & 0x0ffffffff;
      H1 = (H1 + B) & 0x0ffffffff;
      H2 = (H2 + C) & 0x0ffffffff;
      H3 = (H3 + D) & 0x0ffffffff;
      H4 = (H4 + E) & 0x0ffffffff;
    }
    temp = cvt_hex(H0) + cvt_hex(H1) + cvt_hex(H2) + cvt_hex(H3) + cvt_hex(H4);

    return temp.toLowerCase();
  }

  myAisToken() {
    if (this.userData) {
      let randomChar = Math.random().toString(36).substr(2, 4);
      let firstConvert = this.SHA1("a#BAC@21" + randomChar);
      this.myaisToken = randomChar.concat(firstConvert);
      this.myaisToken;
      if (this.devEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.eca.dev.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (this.testEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.eca.test.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.eca.uat.nascorp.vn/loginservice/${this.myaisToken}`);
      } else if (this.procEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.vn/loginservice/${this.myaisToken}`);
      } else if (this.localEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = `http://myais.eca.dev.nascorp.vn/loginservice/${this.myaisToken}`);
      }
    } else {
      // Redirect to desired URL
      if (this.devEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = "http://services.eca.dev.nascorp.vn");
      } else if (this.testEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = "http://services.eca.test.nascorp.vn");
      } else if (this.stagingEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = "http://services.eca.uat.nascorp.vn");
      } else if (this.procEnv.indexOf(this.hostName) !== -1) {
        return (window.location.href = "https://services.aisvietnam.com");
      } else {
        return (window.location.href =
          "http://services.local.eca.dev.nascorp.vn");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/parent-navigate/ParentNavigateComponent.ts